type PropertyCandidate = {
  id: string;
  property: string;
};

/**
 * Resolves a Search Console property ID from a draft value used in chat/tool input.
 *
 * When the model passes a property URL/name (instead of an ID), confirmation UI
 * can still preselect the intended property by matching against current workspace
 * candidates. If the match is ambiguous, this returns `null` to force explicit
 * user choice.
 */
export function resolvePropertyIdFromDraft(args: {
  draftProperty?: string;
  candidates: PropertyCandidate[];
}): string | null {
  const draftProperty = args.draftProperty?.trim();
  if (!draftProperty) {
    return null;
  }

  const byId = args.candidates.filter(
    (candidate) => candidate.id === draftProperty,
  );
  if (byId.length === 1) {
    return byId[0]!.id;
  }

  const byProperty = args.candidates.filter(
    (candidate) => candidate.property === draftProperty,
  );
  if (byProperty.length === 1) {
    return byProperty[0]!.id;
  }

  return null;
}
